import * as React from "react";
import { useSettings } from "@Tmp/Hooks";
import clsx from "clsx";
import { CountryProps } from "./Country.types";

function Country({ select: SelectInput = {}, disabled = false, ...props }: CountryProps) {
    const tmpSettings = useSettings();

    props.errorMessage = props.errorMessage ? props.errorMessage : props.error?.message;

    const onChange = (e) => {
        if (props?.onChange) {
            props?.onChange(e.target.value);
        }
    };

    return (
        <label className={clsx(props?.classes?.wrapper, ["tmp-label", "tmp-country"])}>
            {props?.label ? <div className="tmp-label-text">{props?.label}</div> : null}
            <div
                className={clsx("tmp-input-container", {
                    "tmp-disabled": disabled || SelectInput.disabled,
                    "tmp-input-error": props.errorMessage,
                })}
            >
                {props?.country?.iconBefore ? (
                    <div className="tmp-input-icon-container">
                        <i className={props?.country?.iconBefore}></i>
                    </div>
                ) : null}
                <select
                    className={clsx(props?.classes.select, ["tmp-input", "tmp-select"])}
                    value={props?.value ? props?.value : "default"}
                    onChange={onChange}
                    {...SelectInput}
                    disabled={disabled || SelectInput.disabled}
                >
                    <option disabled={true} value="default">
                        {props?.chooseText ? props?.chooseText : "Vælg et land"}
                    </option>
                    {tmpSettings.countries?.map((country) => (
                        <option key={country?.iso_2} value={country?.iso_2}>
                            {country?.name}
                        </option>
                    ))}
                </select>
                {props?.iconAfter ? (
                    <div className="tmp-input-icon-container">
                        <i className={props?.iconAfter}></i>
                    </div>
                ) : null}
            </div>
            {props.errorMessage && (
                <div className="tmp-input-error-message">{props.errorMessage}</div>
            )}
            {props.successMessage && (
                <div className="tmp-input-success-message">{props.successMessage}</div>
            )}
        </label>
    );
}

export default Country;
